import Vue from "vue";
// 页面标题管理
export let pageTitle = '';
export function setPageTitle(title) {
  pageTitle.value = title;
  document.title = title;
}
export const isiOS = !!navigator.userAgent.match(/(iPhone|iPod|iPad);?/i);
export let safe_area_inset_bottom = 24;
export let padding_bottom_ios = 4;
export let padding_bottom_default = 10;

export let statusBarHeight = 44;
export let navigationBarHeight = 44;
export const navHeight = !isWeixin() ? statusBarHeight + navigationBarHeight : 0;

export const wxTopHeight = !isWeixin() ? statusBarHeight + 36 : 0;
export function objFreeze(obj) {
  // 判断是否为已经被冻结的对象，如果是则直接返回该对象
  if (Object.isFrozen(obj)) {
    return obj;
  }
  // 遍历获取到的对象key,判断是否为 object 类型 如果是则递归执行此函数
  Object.keys(obj).forEach(item => {
    typeof obj[item] === "object" ? objFreeze(obj[item]) : obj[item];
  });
  return Object.freeze(obj);
}

export function setNav() {
  AlipayJSBridge.call(
    "aiaHiddenNavigationBar",
    {
      showNavigationBar: false,
      changeWebViewFrame: false
    },
    function () { }
  );
}
export function deleteNav() {
  AlipayJSBridge.call(
    "aiaHiddenNavigationBar",
    {
      showNavigationBar: true,
      changeWebViewFrame: true
    },
    function () { }
  );
}
export function aiaGetNativeConfigInformation(params) {
  new Promise(() => {
    //先判断AliPayJSBridge对象是否已存在
    isAlipayJSBridge(API => {
      API.call("aiaGetNativeConfigInformation", params, res => {
        if (isiOS) {
          statusBarHeight = parseInt(res.statusBarHeight);
          navigationBarHeight = parseInt(res.navigationBarHeight);
        } else {
          statusBarHeight =
            parseInt(res.statusBarHeight) / window.devicePixelRatio;
          navigationBarHeight =
            parseInt(res.navigationBarHeight) / window.devicePixelRatio;
        }
      });
    });
  });
}

export function phoneHide(phone) {
  let reg = /^(1[3-9][0-9])\d{4}(\d{4}$)/; // 定义手机号正则表达式
  if (phone) {
    phone = phone.replace(reg, "$1****$2");
  }
  return phone; // 输出为131****1234
}

export function toChinesNum(num) {
  const arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  const arr2 = [
    "",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿"
  ];
  if (!num || isNaN(num)) return "零";
  const english = num.toString().split("");
  let result = "";
  for (let i = 0; i < english.length; i++) {
    const des_i = english.length - 1 - i; // 倒序排列设值
    result = arr2[i] + result;
    const arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十"); // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零+/g, "零"); // 合并中间多个零为一个零
  result = result.replace(/零亿/g, "亿").replace(/零万/g, "万"); // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/亿万/g, "亿"); // 将【亿万】换成【亿】
  result = result.replace(/零+$/, ""); // 移除末尾的零
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, "十");
  return result;
}

/* 生成当前时间戳对应的62进制形式短链接 */
export const shorten = function () {
  let DIGITS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  let seq = new Date().getTime();
  let len = DIGITS.length;
  let arr = [];
  do {
    arr.unshift(DIGITS.charAt(seq % len));
    seq = parseInt(seq / len);
  } while (seq !== 0);
  return arr.join("");
};

export const formatName = function (name) {
  let newStr;
  if (name.length === 2) {
    newStr = name.substr(0, 1) + "*";
  } else if (name.length > 2) {
    let char = "";
    for (let i = 0, len = name.length - 2; i < len; i++) {
      char += "*";
    }
    newStr = name.substr(0, 1) + char + name.substr(-1, 1);
  } else {
    newStr = name;
  }
  return newStr;
};

export const onJudgement_price_type = val => {
  const { cash, yx, vcoin } = val;
  let type = "";
  if (cash !== 0 && yx === 0 && vcoin === 0) {
    type = "现金(微信支付)";
  } else if (cash === 0 && yx !== 0 && vcoin === 0) {
    type = "友星";
  } else if (cash === 0 && yx === 0 && vcoin !== 0) {
    type = "V星";
  } else if (cash !== 0 && yx !== 0 && vcoin === 0) {
    type = "现金(微信支付)+友星";
  } else if (cash !== 0 && yx === 0 && vcoin !== 0) {
    type = "现金(微信支付)+V星";
  } else if (cash !== 0 && yx !== 0 && vcoin !== 0) {
    type = "现金(微信支付)+友星+V星";
  } else if (cash === 0 && yx !== 0 && vcoin !== 0) {
    type = "友星+V星";
  }
  return type;
};

export const formatMoney = amount => {
  if (Number.isInteger(amount)) {
    return amount;
  } else {
    const roundedAmount = Math.round((amount + Number.EPSILON) * 100) / 100;
    return roundedAmount.toFixed(2);
  }
};

function isHttpUrl(url) {
  return /^https?:\/\//.test(url);
}
function startsWithSlash(str) {
  return /^\//.test(str);
}
export function isApp() {
  return typeof window.AlipayJSBridge !== "undefined";
}

// 等待 AlipayJSBridge 就绪后回调（解决 bridge 异步注入的时序问题）
export function JSBridgeReady(callback) {
  if (window.AlipayJSBridge) {
    callback && callback();
  } else {
    document.addEventListener("AlipayJSBridgeReady", callback, false);
  }
}
export const is_weixin = isWeixin();
function isWeixin() {
  let userAgent = navigator.userAgent;
  if (userAgent.indexOf("MicroMessenger") > -1) {
    // 在微信小程序内部打开
    return true;
  } else {
    // 不在微信小程序内部打开
    return false;
  }
}
export function getCookie() {
  let cookies = {};
  // 获取所有的Cookie
  let allCookies = document.cookie;
  // 分割成单个Cookie
  let cookiesArray = allCookies.split(";");

  // 遍历所有的Cookie
  for (let i = 0; i < cookiesArray.length; i++) {
    let cookie = cookiesArray[i].trim(); // 去除空格
    let cookieName = cookie.split("=")[0]; // 获取Cookie名称
    let cookieValue = cookie.split("=")[1]; // 获取Cookie值
    cookies[cookieName] = cookieValue;
  }
  return cookies;
}
